/**
 * <s-ask-lachi> — guided "Ask Lachi" helper.
 * Questions are native <details name="ask-lachi"> (one open at a time, works without JS).
 * This element only reports usage through Shopify customer events so a custom pixel
 * (Settings > Customer events) can forward them to an analytics tool:
 *   ask_lachi_opened  { page }
 *   ask_lachi_topic   { topic, page }
 */
class SAskLachi extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    this.querySelector('[data-ask-lachi-open]')?.addEventListener('click', () => {
      this.#publish('ask_lachi_opened', {});
    }, opts);

    // <details> toggle does not bubble, so listen in the capture phase.
    this.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      this.#publish('ask_lachi_topic', { topic: details.dataset.topic || '' });
      requestAnimationFrame(() => details.scrollIntoView({ block: 'nearest', behavior: 'smooth' }));
    }, { ...opts, capture: true });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #publish(name, data) {
    try {
      window.Shopify?.analytics?.publish?.(name, { ...data, page: window.location.pathname });
    } catch (e) {
      /* tracking must never break the helper */
    }
  }
}

if (!customElements.get('s-ask-lachi')) customElements.define('s-ask-lachi', SAskLachi);
